import { aludraApi } from 'Api/axios'
import { coreUrls } from './core.urls'

export const getCustomerDisplaySetting = async id => {
  return aludraApi.get(`${coreUrls.customerDisplaySettingsURL}?Id=${id}`)
}

export const searchCustomerDisplaySettings = async payload => {
  return aludraApi.post(
    `${coreUrls.customerDisplaySettingsURL}/search`,
    payload
  )
}

export const createCustomerDisplaySetting = async payload => {
  return aludraApi.post(`${coreUrls.customerDisplaySettingsURL}`, payload)
}

export const updateCustomerDisplaySetting = async payload => {
  return aludraApi.put(`${coreUrls.customerDisplaySettingsURL}`, payload)
}
